import Spline from '@splinetool/react-spline';
import { FC, useState } from 'react';
import cn from 'classnames';
import type { HeroDefaultProps } from '.';
import { useDeviceDetect } from 'react-scale/hooks/use-device-detect';
import Image from 'next/image';

export type HeroWithSpline = {
  scene: string;
  image: never;
  video: never;
  content: never;
  mobileImage: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
} & HeroDefaultProps;

const SplineAsset: FC<{
  scene: HeroWithSpline['scene'];
  mobileImage: HeroWithSpline['mobileImage'];
}> = ({ scene, mobileImage }) => {
  const { isDesktop } = useDeviceDetect();
  const [splineLoaded, setSplineLoaded] = useState(false);

  return (
    <div className="w-full lg:w-auto">
      {isDesktop ? (
        <>
          <Image
            className={cn('hidden lg:block', splineLoaded && 'opacity-0')}
            src={mobileImage?.src}
            alt={mobileImage?.alt}
            width={mobileImage?.width}
            height={mobileImage?.height}
            quality={100}
            priority
            loading="eager"
          />
          <Spline
            className={cn(
              'lg:absolute lg:right-0 lg:top-1/2 lg:-translate-y-1/2 !w-full lg:!w-[calc(60%-168px)] !h-auto',
              !splineLoaded && 'opacity-0'
            )}
            scene={scene}
            onLoad={() => setSplineLoaded(true)}
          />
        </>
      ) : (
        <Image
          src={mobileImage?.src}
          alt={mobileImage?.alt}
          width={mobileImage?.width}
          height={mobileImage?.height}
          layout="responsive"
          quality={100}
          priority
          loading="eager"
        />
      )}
    </div>
  );
};

export default SplineAsset;
